var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.value.value.value)?_c('div',{staticStyle:{"color":"green"}},[_vm._v("Ano")]):_vm._e(),(!_vm.value.value.value)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Ne")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }